import React from 'react';
import { cn } from 'lib/utils';

const variants = {
  default: 'bg-slate-100 text-slate-700 border border-slate-200',
  success: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  info: 'bg-blue-100 text-blue-700 border border-blue-200',
  danger: 'bg-rose-100 text-rose-700 border border-rose-200',
};

export function Badge({ className = '', variant = 'default', ...props }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-1 text-xs font-semibold',
        variants[variant] || variants.default,
        className
      )}
      {...props}
    />
  );
}

